import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController, NavParams } from '@ionic/angular';
import { Observable } from 'rxjs';
import { IproposalMethod } from '../../services/bodyAll';

@Component({
  selector: 'app-p2p-method',
  templateUrl: './p2p-method.component.html',
  styleUrls: ['./p2p-method.component.scss'],
})
export class P2pMethodComponent implements OnInit {
  methods: IproposalMethod[];
  method: string;


  constructor(
    public navParams: NavParams,
    public translate: TranslateService,
  	public popover: PopoverController,

  ) { 
    console.log("params")
    console.log(this.navParams.get('methods'))
    console.log(this.navParams.get('method'))
    this.methods = this.navParams.get('methods')
    let objectMethod= this.navParams.get('method')
    this.method = objectMethod?.value ? objectMethod?.value : 'all'
    console.log(this.method)
  }

  ngOnInit() {}

  selecMethod(method){
    this.popover.dismiss({method});
  }

}
